module.exports = __webpack_public_path__ + "img/NEW.5f09a6b7.png";